export default __webpack_public_path__ + "static/media/close-icon-in-modal.d7ed27a0.svg";